import request from '../request';

export const getFormStructure = (url: string) => {
  return request(url);
};
